import {DCIM_SERVER} from "@/api";
import {RestResource} from '@/api/rest'
import {athubAxios} from "@/util";

const point = new RestResource({server: DCIM_SERVER, resource: 'point'});

point.getRealTimeValuesByGuids = (guids) => {
    let url = `${DCIM_SERVER}/point/realTimeValues`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, guids).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

point.getPointRealTimes = (guids) => {
    let url = `${DCIM_SERVER}/point/real-time-value/guid`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, guids).then(responseBody => {
            if (responseBody.status === 200) {
                resolve(responseBody.data.data);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

point.upload = (params) => {
    return new Promise((resolve, reject) => {
        let url = `${DCIM_SERVER}/point/importExcel/type/${params.type}`;
        athubAxios.postByMultipartForm(url, params).then(responseBody => {
            if (responseBody.status == 200 && responseBody.data.code == 200) {
                resolve(responseBody.data.code);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

point.download = (params) => {
    return new Promise((resolve, reject) => {
        let url = `${DCIM_SERVER}/point/exportExcel`;
        athubAxios.post(url, params, {responseType: 'blob'}).then(responseBody => {
            if (responseBody.status == 200) {
                let blob = responseBody.data;
                let reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = function (e) {
                    var a = document.createElement('a');
                    a.download = '点位导出结果.xlsx';
                    a.href = e.target.result;
                    $("body").append(a);
                    a.click();
                    $(a).remove();
                }
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default point;
